export const TextToBuyDrawerTypes = {
  T2B_PREVIEW_CANCELLED: 'T2B_PREVIEW_CANCELLED',
  T2B_PREVIEW_DIDNT_PURCHASE: 'T2B_PREVIEW_DIDNT_PURCHASE',
  T2B_PREVIEW_PURCHASED: 'T2B_PREVIEW_PURCHASED',
  T2B_PREVIEW_TIMED_OUT: 'T2B_PREVIEW_TIMED_OUT',
} as const;

export const DrawerTypes = {
  ...TextToBuyDrawerTypes,
  ACTIVATE: 'ACTIVATE',
  AI_INSIGHTS: 'AI_INSIGHTS',
  AI_MANAGED_MESSAGE: 'AI_MANAGED_MESSAGE',
  CONFIRM_CREATE_VERSION: 'CONFIRM_CREATE_VERSION',
  DEACTIVATE: 'DEACTIVATE',
  FLOW_VERSIONS: 'FLOW_VERSIONS',
  LINKED_FLOWS: 'LINKED_FLOWS',
  OPTIMIZED_AB_SPLIT_TEST_HISTORY: 'OPTIMIZED_AB_SPLIT_TEST_HISTORY',
  RCS_MEDIA_REQUIREMENTS: 'RCS_MEDIA_REQUIREMENTS',
  SAVE_FLOW_VERSION: 'SAVE_FLOW_VERSION',
} as const;

export const VersionOptions = {
  UPDATE_CURRENT: 'UPDATE_CURRENT',
  SAVE_NEW: 'SAVE_NEW',
} as const;
